import { Categoria } from '@/types/app';

// Categorias padrão
export const categoriasPadrao: Categoria[] = [
  { id: 'comida', nome: 'Comida & Bebida', emoji: '🍕', cor: '#FF6B6B', icone: 'Utensils' },
  { id: 'transporte', nome: 'Transporte', emoji: '🚗', cor: '#4ECDC4', icone: 'Car' },
  { id: 'hospedagem', nome: 'Hospedagem', emoji: '🏨', cor: '#45B7D1', icone: 'Hotel' },
  { id: 'entretenimento', nome: 'Entretenimento', emoji: '🎬', cor: '#96CEB4', icone: 'Film' },
  { id: 'shopping', nome: 'Shopping', emoji: '🛍️', cor: '#FFEAA7', icone: 'ShoppingBag' },
  { id: 'saude', nome: 'Saúde', emoji: '💊', cor: '#A8E6CF', icone: 'Heart' },
  { id: 'educacao', nome: 'Educação', emoji: '📚', cor: '#FFB347', icone: 'Book' },
  { id: 'outros', nome: 'Outros', emoji: '📦', cor: '#DDA0DD', icone: 'Package' },
];